import axiosInstance from "app/axiosInstance";
import { GeozonesRequestDto } from "../entities/dtos/geozones-request.dto";

export const getGeozones = async (payload: GeozonesRequestDto) => {
  try {
    const { accountId } = payload;
    const response = await axiosInstance.get(`/accounts/${accountId}/geozones`);

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
